import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-text">
        &copy; 2025 Vidya KP Astrology Predictions. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
